<div class="container">
  @if (!tosFetched) {
    <mat-spinner diameter="30" color="accent"></mat-spinner>
  }
  @if (tosFetched) {
    <div class="tos-content" [appSanitizedHtml]="tosHTML"></div>
  }
</div>